import { memo, useEffect, useRef } from "react";

function Dropdown({
  selectedOption,
  handleOptionClick = () => {},
  dropdownOptions = [],
  dropdownClassName = "",
  dropdownOptionClassName = "",

}) {
  return (
    <div
      className={`absolute border bg-white-default z-10 overflow-auto ${dropdownClassName}`}
      id="generic_dropdown"
    >
      <ul className="w-full">
        {dropdownOptions.map((option, index) => (
          <li
            key={option.key || index}
            className={`p-2 py-[10px] rounded-lg  font-medium text-sm cursor-pointer hover:bg-gray-100 w-full ${dropdownOptionClassName} ${
              option.class || ""
            } ${
              option.key === selectedOption?.key
                ? " text-spyne-blue selected"
                : "text-[#00000099]"
            }`}
            onClick={() => handleOptionClick(option)}
          >
            {option.text}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default memo(Dropdown);
